import styled from "styled-components";

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
`;

const SafeSignImage = styled.img`
  position: absolute;
  bottom: 10px;
  width: 150px;
`;

const modules = {
  RootContainer,
  SafeSignImage,
};

export default modules;
